import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './componenet/HeroSection';
import MemberCommunication from './componenet/MemberCommunication';
import BenefitSpeech from './componenet/BenefitSpeech';

const SpeechTherapyPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Pediatric Speech Therapy Wasilla Alaska | Guidepost SLP Services
        </title>
        <meta
          name="description"
          content="Pediatric speech therapy services in Wasilla, Alaska. Our speech-language pathologists help children improve communication, articulation, and language skills for academic and social success."
        />
        <meta
          name="keywords"
          content="pediatric speech therapy Wasilla, SLP services Alaska, speech therapy for children, language therapy Wasilla, articulation therapy Alaska"
        />
      </Helmet>
      <HeroSection />
      <MemberCommunication />
      <BenefitSpeech />
    </div>
  );
};

export default SpeechTherapyPage;
